module.exports = __webpack_public_path__ + "createstatic/media/alignIcn.03890f14.svg";